import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';

import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import Floater from 'react-floater';
import { palette, breakpoints } from '../../constants/styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import Modal from '../shared/Modal';
import ResultSubsection from '../shared/ResultSubsection';
import Icon from '../shared/Icon';
import HoverCard from '../shared/HoverCard';

const StyledTooltip = css`
  width: 80vw;
  height: fit-content;
  padding: 20px;

`;

export const StyledPortionDiv = styled.div`
  &:hover {
    z-index:10000000;
    -moz-box-shadow: 0 0 5px black;
    -webkit-box-shadow: 0 0 5px black;
    box-shadow: 0px 0px 5px black;
  }
`;


export const StyledResultTableSavings = styled.tbody`
  & > tr > th {
    padding: 0px;
    border-bottom: none;
  }
  & > tr > * {
    ${({ borderColor }) => borderColor && css`
      border-bottom: 1px solid ${borderColor};
    `}
    padding: 5px;
    text-align: center;

    // Colors
    &:nth-child(1) {
      width: 20px;
      text-align: left;
    }
    // Labels
    &:nth-child(2) {
      width: 50%;
      text-align: left;
    }
    // Info
    &:nth-child(3) {
      width: 20px;
    }
    // Money
    &:nth-child(4) {
      width: 30%;
      ${({ borderColor }) => borderColor && css`
        border-left: 1px solid ${borderColor};
      `}
    }
    // Percentage
    &:nth-child(5) {
      width: 20%;
      ${({ borderColor }) => borderColor && css`
        border-left: 1px solid ${borderColor};
      `}
    }
  }
`;

const DiagnosticTable = ({
  entries, section, borderColor, hideGraph, totalBreakdown, colorPalette,
}) => {
  let total = 0;
  entries.forEach((entry) => {
    total += entry.number;
  });
  console.log(entries);

  return (
    <Fragment>
      {!hideGraph && (
        <div
          style={{
            height: '15px',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          {
            entries.map(entry => (
              <StyledPortionDiv
                key={`${section}-${entry.label}`}
                style={{
                  backgroundColor: entry.color,
                  width: `${(entry.number / total) * 100}%`,
                  height: '100%',
                }}
                data-tip
                data-for={entry.label}
              >
                <ReactTooltip id={`${entry.label}`}>{entry.label}</ReactTooltip>
              </StyledPortionDiv>
            ))
          }
        </div>
      )}

      <table cellPadding={0} cellSpacing={0} style={{ width: '100%', margin: '10px 0px 0px 0px' }}>
        <StyledResultTableSavings borderColor={borderColor}>
          {
            entries.map((entry, i) => (
              <tr key={`${section}-${entry.label}-table`}>
                <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }}>
                  <Icon icon="emptyCircle" color={totalBreakdown ? colorPalette : entry.color} size={15} styles={{ verticalAlign: 'middle' }} />
                </td>

                <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }}>
                  <Text type="body1">
                    {entry.label}
                  </Text>
                </td>

                {entry.info ? (
                  <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }}>
                    <Floater
                      event="hover"
                      styles={{
                        arrow: {
                          length: 8,
                          spread: 16,
                        },
                      }}
                      offset={8}
                      component={(
                        <HoverCard
                          styles={StyledTooltip}
                        >
                          <Text>
                            {entry.info.description}
                          </Text>
                          {entry.info.breakdown && (
                            <DiagnosticTable
                              entries={entry.info.breakdown}
                              section={entry.label}
                              borderColor="#ddd"
                              hideGraph
                              colorPalette={entry.color}
                              totalBreakdown={entry.number}
                            />
                          )}
                        </HoverCard>
                      )}
                    >
                      <Icon icon="info" color={palette.terciaryColor} size={13} style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }} />
                    </Floater>
                  </td>
                ) : (
                  <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }} />
                )}

                <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }}>
                  <Text type="body1" color={totalBreakdown ? colorPalette : entry.color} bold><NumberFormat style={{ marginRight: '5px' }} value={entry.number} displayType="text" thousandSeparator prefix="$" decimalScale={0} /></Text>
                </td>
                {!totalBreakdown
                  && (
                    <td align="center" style={{ borderBottom: (i < entries.length - 1) ? '' : 'none' }}>
                      <Text type="body1" color={entry.color} bold><NumberFormat style={{ marginRight: '5px' }} value={entry.number / total * 100} displayType="text" suffix="%" decimalScale={0} /></Text>
                    </td>
                  )}
              </tr>
            ))
          }
          {(totalBreakdown && entries.length !== 0) && (
            <tr>
              <td align="center" style={{ borderBottom: 'none', borderTop: `1px solid ${borderColor}` }} />
              <td align="center" style={{ borderBottom: 'none', borderTop: `1px solid ${borderColor}` }}>
                <Text type="body1" align="right">
                  Total
                </Text>
              </td>
              <td align="center" style={{ borderBottom: 'none', borderTop: `1px solid ${borderColor}` }} />
              <td align="center" style={{ borderBottom: 'none', borderTop: `1px solid ${borderColor}` }}><Text type="body1" color={colorPalette} bold><NumberFormat style={{ marginRight: '5px' }} value={totalBreakdown} displayType="text" thousandSeparator prefix="$" decimalScale={0} /></Text></td>
            </tr>
          )}
        </StyledResultTableSavings>
      </table>
    </Fragment>
  );
};

export default DiagnosticTable;
